import { useEffect } from "react";
import { cancelPayment } from "@api";
import { formatAmount } from "@utils";

const useUpdatePaymentRequest = ({ isOpen, updateRequestData, setValue, handleCommsSelected }) => {
  useEffect(() => {
    if (!isOpen || !updateRequestData) return;
    const newAmount = updateRequestData.amountRequested || 0;
    const formattedAmount = formatAmount(newAmount);

    setValue("amount", newAmount);
    setValue("reference", updateRequestData.reference || "");
    setValue("customerName", updateRequestData.customerName || "");
    setValue("phone", updateRequestData.sms?.to || "");
    setValue("email", updateRequestData.email?.to || "");

    const cancellationLine = `Your previous payment link for ${formattedAmount} has been cancelled.`;
    const baseMsg = `The new amount due is ${formattedAmount}. Please make a payment to using the link below.`;
    setValue("message", `${cancellationLine}\n\n${baseMsg}`);

    const methodMap = { Sms: "sms", Email: "email", Link: "share", QrCode: "qr" };
    const tab = methodMap[updateRequestData.communicationMethod];
    if (tab) handleCommsSelected(tab);
  }, [isOpen, updateRequestData]);

  const cancelIfNeeded = async () => {
    if (updateRequestData?.id) {
      await cancelPayment(updateRequestData.id);
    }
  };

  return { cancelIfNeeded };
};

export default useUpdatePaymentRequest;
